import { Alert, List } from '@mantine/core';
import React from 'react';
import { SecondaryButton } from 'src/design/atoms/SecondaryButton';

export interface IUploadProblemAlertProps {
  /** One already-user-facing line per problem, e.g. 'plan.pdf: File is larger than 10 MB'. */
  problems: string[];
  onClear: () => void;
}

/** @registry Red alert listing per-file attachment problems (rejections, failed uploads, failed downloads) with a Clear action; the single failure surface for FileDrop and ImageUpload. */
export const UploadProblemAlert: React.FC<IUploadProblemAlertProps> = ({
  problems,
  onClear,
}) =>
  problems.length === 0 ? null : (
    <Alert
      color="red"
      mt="xs"
      title={
        problems.length === 1 ? 'Attachment problem' : 'Attachment problems'
      }
    >
      <List mt="xs" size="xs">
        {problems.map((problem, index) => (
          <List.Item key={`${index}:${problem}`}>{problem}</List.Item>
        ))}
      </List>
      <SecondaryButton mt="xs" size="compact-sm" onClick={onClear}>
        Clear
      </SecondaryButton>
    </Alert>
  );
